<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}DriverPermission`"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <form [formGroup]="form" [onyxAutoFocus]="data.mode">
    @let controls = form.controls;
    <app-dictionaries-names-translation-form
      [form]="controls.names"
      label="labels.permissionName"
      [initialValue]="data.mode === OnyxFormMode.ADD ? data.name : undefined"
    ></app-dictionaries-names-translation-form>

    <div
      class="radio"
      [onyxTooltip]="`${I18N}.disabledRequiredExpirationDate`"
      [onyxTooltipDisabled]="controls.requiredExpirationDate.enabled"
    >
      <p class="f-body-l">
        {{ `${I18N}.requiredExpirationDate` | translate }}
      </p>

      <div class="radio-buttons">
        @for (option of ['yes', 'no']; track option) {
          <onyx-radio-button
            [formControl]="controls.requiredExpirationDate"
            [label]="`labels.${option}`"
            [option]="option === 'yes'"
          ></onyx-radio-button>
        }
      </div>
    </div>
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{
        `labels.${data.mode === OnyxFormMode.ADD ? 'add' : 'saveChanges'}`
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
